import { Grid } from "@mui/material";
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { v4 as uuid } from 'uuid';
import { GoToPlansPrimaryIcon, GoToPlansSecondaryIcon, PaymentAwaitedIcon, PaymentFailedIcon, PaymentSuccessIcon, PrintIcon, TryAgainIcon } from "../../icon";
import { PhoneNumberModel } from "../../models/phone-number.model";
import { PlanModel } from "../../models/plans.model";
import { PhoneNumberService } from '../../services/PhonenumberService';
import { UserService } from "../../services/UserService";
import { UtilityService } from '../../services/UtilityService';
import { AppRoutes } from "../routes/route.path";
import ButtonComponent from "../shared/button/button.component";
import { ViewTextLabels, appNote, buttonLabels } from "../shared/constants";
import { useSelector } from "react-redux";
import * as selector from "../../selectors/selectors"

interface Props {
    IsMobileDevice?: boolean;
    IsTeamsApp?: boolean;
    Stepdata?: any;
    HandleNext?: (data: any) => void;
}

const ManualPayment = (props : Props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const PhoneNumbers: PhoneNumberModel[] = useSelector(selector.phoneNumbers)
    const Plans : PlanModel[] = useSelector(selector.plans)
    const getPrice = () => {
        let price = 0;
        if (!!props.Stepdata.Plan) {
            if (Object.keys(props.Stepdata.Addons).length === 0) {
                price = props.Stepdata.Tenure === "A" ? props.Stepdata.Plan.YearlyPrice : props.Stepdata.Plan.Price
            }
            else if (Object.keys(props.Stepdata.Addons).length !== 0) {
                price = Plans.filter(x => props.Stepdata.Addons.hasOwnProperty(x.PlanID)).map(y => y.Price * props.Stepdata.Addons[y.PlanID])
                    .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
                    + (props.Stepdata.Tenure === "A" ? props.Stepdata.Plan.YearlyPrice : props.Stepdata.Plan.Price);
            }
        }
        else {
            price = Plans.filter(x => props.Stepdata.Addons.hasOwnProperty(x.PlanID))
                .map(y => y.Price * props.Stepdata.Addons[y.PlanID])
                .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
        }
        return Number(price.toFixed(2))
    }

    const { state } = useLocation();
    const [currentPhoneNumber, setcurrentPhoneNumber] = useState<PhoneNumberModel>(PhoneNumbers.find((phoneNumber) => phoneNumber.ID === state?.PhoneNumberID));
    const [phoneNumberDetails, setPhoneNumberDetails] = useState<{
        subscriptionId: string,
        PhoneNumber: string,
        Plan: string,
        Price: number,
        Date: string
    }>
        ({
            subscriptionId: uuid(),
            PhoneNumber: !!currentPhoneNumber ? currentPhoneNumber?.PhoneNumber : state?.PhoneNumber,
            Plan: !!props.Stepdata.Plan ? !!props.Stepdata.Addons ? [...Plans.filter(x => props.Stepdata.Addons.hasOwnProperty(x.PlanID)).map(y => y.Name), props.Stepdata.Plan.Name].join(', ') : props.Stepdata.Plan.Name : Plans.filter(x => props.Stepdata?.Addons.hasOwnProperty(x.PlanID)).map(y => y.Name).join(', '),
            Price: getPrice(),
            Date: new Date().toISOString().slice(0, 10)
        })
    const [paymentwaiting, setPaymentWaiting] = useState<boolean>(false)
    const [paymentFailed, setPaymentFailed] = useState<boolean>(false)
    const [paymentSuccess, setPaymentSuccess] = useState<boolean>(false)

    useEffect(() => {
        const data = {
            "phoneId": state?.PhoneNumberID,
            "planId": !!props.Stepdata.Plan ? props.Stepdata.Plan.PlanID : currentPhoneNumber?.CurrentPlanID,
            "isYearPlan": props.Stepdata.Tenure === "A" ? true : false,
            "subscriptionId": uuid(),
            "addOnPlans": Object.keys(props.Stepdata.Addons)
        }
        setPaymentWaiting(true)
        PhoneNumberService.manualPayment(state?.PhoneNumberID, data)
            .then((res) => {
                setPaymentFailed(false)
                setPaymentWaiting(false)
                setPaymentSuccess(true)
            })
            .catch((err) => {
                setPaymentSuccess(false)
                setPaymentWaiting(false)
                setPaymentFailed(true)
            })
    }, [])

    const handlePrint = () => {
        window.print();
    }
    const goToHome = (e: any) => {
        e.preventDefault()
        navigate(UserService.hasSysAdminRole() ? AppRoutes.PHONE_NUMBERS : AppRoutes.PLANS)
    }
    const showTryAgain = () => {
        return location.pathname === AppRoutes.RECHARGE || location.pathname === AppRoutes.ADD_PHONE_NUMBER || location.pathname === AppRoutes.SIGN_UP
    }
    const handleTryAgain = () => {
        (global as any).paymentID = "";
        if (showTryAgain()) {
            navigate(location.pathname, { state: { ...(location.state as any), step: (location.state as any)?.step ? (location.state as any)?.step - 1 : 1 }, replace: true });
        }
    }
    return (
        paymentSuccess === true ?
            <div className={`d-flex flex-direction align-center p-5 justify-center w-p-100 b-none ${(location.state as any)?.IsSignUp || ((location.state as any)?.IsRecharge && props.IsMobileDevice) ? '' : ''}  `}>
                <div className={` ${props.IsMobileDevice ? 'w-p-100' : ' h-50 w-p-70  settings-paper-border px-10 br-3  '} t-align-center printme`}>
                    <div id="print">
                        <div className={`pt-2`}> <PaymentSuccessIcon /> </div>
                        <div className={`h1-semibold color-primary-success pb-1 pt-1`} >{appNote.PAYMENT_SUCCESSFUL} </div>
                        <div className="h4-regular color-secondary-accent pb-4">{appNote.THANK_YOU_FOR_PAYMENT}<br /> {appNote.PROCESSED_SUCCESSFULLY}</div>
                        <div className="bb-primary-background-pink-4"></div>

                        <Grid container justifyContent="center" className={"mt-3"} direction="row" spacing={3}>
                            <Grid item xs={props.IsMobileDevice ? 12 : 6} md={6}>
                                <Grid container >
                                    <Grid item xs={6} className={`h5-semibold color-primary-accent t-align-left pb-1 ${phoneNumberDetails.subscriptionId.length > 22 ? 'pb-2' : 'pb-1'}`} style={phoneNumberDetails.subscriptionId.length > 22 ? { paddingTop: '0.1rem' } : {}}>
                                        {ViewTextLabels.PHONE_NUMBER}
                                    </Grid>
                                    <Grid item xs={6} className={`${phoneNumberDetails.subscriptionId.length > 22 ? 'mt-0 mb-auto' : 'my-auto'} h6-regular t-align-left`} id="print-font" style={phoneNumberDetails.subscriptionId.length > 22 ? { paddingTop: '0.1rem' } : {}}>
                                        {UtilityService.maskPhoneNumber(phoneNumberDetails.PhoneNumber)}
                                    </Grid>
                                    <Grid item xs={6} className={`h5-semibold color-primary-accent t-align-left pb-1`} >
                                        {ViewTextLabels.PLANS}
                                    </Grid>
                                    <Grid item xs={6} className={`h6-regular t-align-left ${phoneNumberDetails.subscriptionId.length > 22 ? 'mt-0 mb-auto' : 'my-auto'}`} id="print-font">
                                        {phoneNumberDetails.Plan || "--"}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={props.IsMobileDevice ? 12 : 6} md={6}>
                                <Grid container>
                                    <Grid item xs={6} className={`h5-semibold color-primary-accent t-align-left ${phoneNumberDetails.subscriptionId.length > 22 ? 'pb-2' : 'pb-1'} `}>
                                        {ViewTextLabels.PRICE}
                                    </Grid>
                                    <Grid item xs={6} className={`h6-regular t-align-left ${phoneNumberDetails.subscriptionId.length > 22 ? 'mt-0 mb-auto' : 'my-auto'}`} id="print-font">
                                        {phoneNumberDetails.Price > 0 && '$'}{phoneNumberDetails.Price > 0 ? phoneNumberDetails.Price : "--"}
                                    </Grid>
                                    <Grid item xs={6} className={`h5-semibold color-primary-accent t-align-left pb-1`}>
                                        {ViewTextLabels.DATE}
                                    </Grid>
                                    <Grid item xs={6} className={`${phoneNumberDetails.subscriptionId.length > 22 ? 'mt-0 mb-auto' : 'my-auto'} h6-regular t-align-left`} id="print-font">
                                        {phoneNumberDetails.Date || "--"}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                    <div className={`${props.IsMobileDevice ? 'mx-auto' : 'd-flex t-align-center justify-center p-1'} mt-3 no-printme`}>
                        <ButtonComponent OnClick={handlePrint}
                            ButtonLabel={buttonLabels.PRINT.toLocaleUpperCase()}
                            ClassName={`c-pointer  ${props.IsMobileDevice ? 'w-p-100 justify-center mb-2' : 'mr-2'} `}
                            Variant={"secondary-btn-small"}
                            Icon={PrintIcon}
                        />
                        <ButtonComponent OnClick={goToHome}
                            ButtonLabel={(location.state as any)?.IsSignUp ? buttonLabels.BACK_TO_LOGIN : UserService.hasSysAdminRole() ? buttonLabels.GO_TO_PHONE_NUMBERS : buttonLabels.GO_TO_PLANS}
                            ClassName={`c-pointer  ${props.IsMobileDevice ? 'w-p-100 justify-center mb-2' : 'mr-2'}`}
                            Variant={"primary-btn-small"}
                            Icon={(location.state as any)?.IsSignUp ? undefined : GoToPlansPrimaryIcon}
                        />
                    </div >
                </div>
            </div >
            : paymentFailed === true ? <div className={`d-flex flex-direction align-center p-5 justify-center w-p-100 b-none ${(location.state as any)?.IsSignUp ? '' : 'paper-background'} mx-auto `}>
                <div className="  h-40 w-p-50  settings-paper-border px-10 br-3 t-align-center printme ">
                    <div id="print">
                        <div className={`pt-4`}>
                            <PaymentFailedIcon />
                        </div>
                        <div className={`h1-semibold pb-1 pt-1 color-primary-danger`}>
                            {appNote.PAYMENT_FAILED}
                        </div>

                        <div className="h3-regular color-secondary-accent pb-4">{appNote.SOMETHING_WENT_WRONG} {appNote.TRY_AGAIN}</div>
                    </div>

                    <div className="d-flex t-align-center justify-center mt-4 no-printme">
                        {showTryAgain() && <ButtonComponent OnClick={handleTryAgain}
                            ButtonLabel={buttonLabels.TRY_AGAIN.toUpperCase()}
                            ClassName={"c-pointer mr-2"}
                            Variant={"primary-btn-small"}
                            Icon={TryAgainIcon}
                        />}
                        <ButtonComponent OnClick={goToHome}
                            ButtonLabel={(location.state as any)?.IsSignUp ? buttonLabels.BACK_TO_SIGN_UP : UserService.hasSysAdminRole() ? buttonLabels.GO_TO_PHONE_NUMBERS : buttonLabels.GO_TO_PLANS}
                            ClassName={"c-pointer mr-2"}
                            Variant={"secondary-btn-small"}
                            Icon={GoToPlansSecondaryIcon}
                        />
                    </div >
                </div>
            </div >
                : paymentwaiting === true && <div className={`d-flex flex-direction align-center p-5 justify-center w-p-100 b-none ${(location.state as any)?.IsSignUp ? '' : 'paper-background'} mx-auto `}>
                    <div className=" t-align-center h-50 w-p-70  settings-paper-border px-10 br-3 ">
                        <div id="print">
                            <div className={`pt-4`}>
                                <PaymentAwaitedIcon />
                            </div>
                            <div className={`h1-semibold pb-1 pt-1 color-primary-warning`}>
                                {appNote.PAYMENT_AWAITED}
                            </div>

                            <div className="h4-regular t-align-center color-secondary-accent pb-4">{appNote.PAYMENT_AWAITED_NOTE}</div>
                        </div>

                        <div className="d-flex t-align-center justify-center mt-5 no-printme">
                            <ButtonComponent OnClick={goToHome}
                                ButtonLabel={(location.state as any)?.IsSignUp ? buttonLabels.BACK_TO_SIGN_UP : UserService.hasSysAdminRole() ? buttonLabels.GO_TO_PHONE_NUMBERS : buttonLabels.GO_TO_PLANS}
                                ClassName={"c-pointer mr-2"}
                                Variant={"primary-btn-small"}
                                Icon={GoToPlansPrimaryIcon}
                            />
                        </div >
                        <div className="footnote t-align-center color-secondary-accent pt-3">{appNote.PAYMENT_AWAITED_FOOT_NOTE}</div>
                    </div>
                </div >

    )
}

export default ManualPayment;
